import { http } from "./http";

export type ScaleGatewayReportListItem = {
  id: string;
  posCode?: string | null;
  hostname?: string | null;
  vendor?: string | null;
  dataDir?: string | null;
  source: string;
  status: string;
  summary: {
    headline?: string;
    overallStatus?: string;
    invalidTotal?: number;
    scaleDetected?: boolean;
    ticketsFound?: boolean;
    gapCounts?: { high: number; medium: number; low: number; info: number };
  };
  analyzedAt: string;
  createdAt: string;
  location?: string | null;
};

export type ScaleGatewayGap = {
  id: string;
  severity: "HIGH" | "MEDIUM" | "LOW" | "INFO" | string;
  area: string;
  title: string;
  detail: string;
  action?: string;
};

export type ScaleGatewayReportDetail = {
  ok: boolean;
  report: {
    id: string;
    posCode?: string | null;
    hostname?: string | null;
    vendor?: string | null;
    dataDir?: string | null;
    source: string;
    status: string;
    summary: Record<string, unknown>;
    findings: Record<string, unknown>;
    diagnostics: Array<{
      id: string;
      label: string;
      ok: boolean;
      detail: string;
      recordCount?: number;
      invalidCount?: number;
    }>;
    gaps: ScaleGatewayGap[];
    recommendations?: { nextSteps?: Array<{ priority: string; title: string; action: string }> };
    capabilities?: Record<string, boolean>;
    rawPayload?: Record<string, unknown>;
    analyzedAt: string;
    createdAt: string;
    posDevice?: {
      code: string;
      name: string;
      location?: { name: string; code: string };
    } | null;
  };
};

export type ScaleLinkRow = {
  id: string;
  name: string;
  host: string;
  connected: boolean;
  lamp: "green" | "red";
  port: number | null;
  latencyMs: number | null;
  message: string;
};

export type ScaleLinkStatus = {
  ok: boolean;
  checkedAt: string;
  location: {
    name: string;
    vendor: string;
    ticketPath: string;
    pluPath: string;
    parser: string;
    driver: {
      name: string;
      installedInCorevian: boolean;
      shopSoftware: string;
      shopPath: string;
      description: string;
    };
  };
  scales: ScaleLinkRow[];
  articles?: {
    count: number;
    filename: string;
    header: string;
    path: string;
    written: boolean;
    message: string;
  };
};

export const scaleLinkApi = {
  status(token: string, scales: Array<{ id: string; name: string; host: string }>) {
    return http<ScaleLinkStatus>("/pos/scales/link/status", { method: "POST", body: JSON.stringify({ scales }) }, token);
  },
  articles(token: string, scales: Array<{ id: string; name: string; host: string }>) {
    return http<ScaleLinkStatus>("/pos/scales/link/articles", { method: "POST", body: JSON.stringify({ scales }) }, token);
  },
};

export const scaleGatewayApi = {
  list(token: string, limit = 30) {
    return http<{ ok: boolean; items: ScaleGatewayReportListItem[] }>(
      `/pos/scales/gateway?limit=${limit}`,
      { method: "GET" },
      token,
    );
  },
  getById(token: string, id: string) {
    return http<ScaleGatewayReportDetail>(`/pos/scales/gateway/${id}`, { method: "GET" }, token);
  },
};
